export function getGuestRestrictionsDescription({
  partnershipGuestRestrictions,
  isPartnership,
  fallbackDescription,
}: {
  partnershipGuestRestrictions?: string | null
  isPartnership?: boolean
  fallbackDescription: string
}): string {
  if (isPartnership && partnershipGuestRestrictions) {
    return partnershipGuestRestrictions
  }

  return fallbackDescription
}

export function getSelectGuestsRestrictionText({
  partnershipGuestRestrictions,
  isPartnershipListing,
}: {
  partnershipGuestRestrictions?: string | null
  isPartnershipListing?: boolean
}): string {
  if (isPartnershipListing && partnershipGuestRestrictions) {
    // Avoid ".." when CMS copy already ends with a period (selector adds one)
    const trimmed = partnershipGuestRestrictions.replace(/\.+$/, '').trim()
    if (!trimmed) return ''
    return `. ${trimmed}`
  }

  return ''
}
